import { create } from 'zustand';
import { api } from '../services/api';

export const useImageStore = create((set, get) => ({
  stats: null,
  list: null,
  isLoading: false,
  error: null,

  // Загрузка статистики
  fetchStats: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getImageStats();
      set({ stats: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка списка изображений
  fetchList: async (page = 1, limit = 20, filterVkUserId = null) => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getImageList(page, limit, filterVkUserId);
      set({ list: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Удаление изображения
  deleteImage: async (id) => {
    try {
      await api.deleteImage(id);
      // Обновляем список после удаления
      const { list } = get();
      if (list) {
        await get().fetchList(list.page, list.limit);
      }
      return true;
    } catch (error) {
      set({ error: error.message });
      return false;
    }
  },

  // Баннер «Рекомендовать бота в ТГ» в приложении
  botBannerEnabled: false,
  botBannerLoading: false,
  botBannerError: null,

  fetchBotBanner: async () => {
    set({ botBannerLoading: true, botBannerError: null });
    try {
      const data = await api.getBotBanner();
      set({ botBannerEnabled: !!data.enabled, botBannerLoading: false });
    } catch (error) {
      set({ botBannerError: error.message, botBannerLoading: false });
    }
  },

  toggleBotBanner: async (enabled) => {
    set({ botBannerLoading: true, botBannerError: null });
    try {
      const data = await api.setBotBanner(enabled);
      set({ botBannerEnabled: !!data.enabled, botBannerLoading: false });
      return true;
    } catch (error) {
      // Не трогаем общий error: иначе страница целиком заменится
      // на экран ошибки. Показываем проблему локально, у кнопки.
      set({ botBannerError: error.message, botBannerLoading: false });
      return false;
    }
  },

  // Очистка
  clear: () => {
    set({ stats: null, list: null, error: null });
  },

  // Сброс ошибки
  clearError: () => {
    set({ error: null });
  },
}));
